// Generated by pnpm icons:generate. Edit native source assets and semantic roles, not this file.
import { createCoreLineIcon } from '../CoreLineIcon';
export const ForwardIcon = /*#__PURE__*/ createCoreLineIcon(
  'forward',
  '0 0 14 14',
  '<g><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m4 0.5 6.1464 6.14645c0.1953 0.19526 0.1953 0.51184 0 0.7071L4 13.5" stroke-width="1"></path></g>',
);
